module.exports = __webpack_public_path__ + "img/trash.8e53b536.svg";